import {gsap} from "gsap";
import App from "@templates/App/App.js";

const Animation = {

    switch(_old, _new, from, to, callback) {
        // console.log('switch', _old, _new, from, to, callback);

        gsap.set(_old, {position: 'absolute'})
        gsap.set(_new, {opacity: 0, position: 'absolute'})

        gsap.timeline()
            .fromTo(_old, {...to}, {
                    ...from, ease: "power2.out", overwrite: true, onComplete: () => {
                        _old.remove();
                        setTimeout(() => {
                            if (callback && typeof callback === "function") callback();
                        }, 1)
                    }
                }, 0
            )
            .fromTo(_new, {...from}, {...to,  position: 'relative', duration: 0.5, ease: "power2.out", overwrite: true, clearProps: 'all'}, 0.2)

        setTimeout(() => {
            gsap.to(_new.parent(), {height: _new.outerHeight(), duration: 0.5, clearProps: true})
        }, 2)
    },

    animate(elms, from, to, delay) {
        // console.log(elms, from, to, delay)
        gsap.timeline({delay: delay}).fromTo(elms, from, to)
    }

}

export default Animation;